import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'excel-date-range-modal',
  template: `
    <div cdkDrag cdkDragRootElement=".modal-dialog">
    <div class="modal-header" cdkDragHandle>
      <h4 class="modal-title">Excel Correlation Report</h4>
    </div>
    <div class="modal-body">
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Start Date</label>
        <div class="col-sm-9">
          <input type="date" class="form-control" [(ngModel)]="startDate">
        </div>
      </div>
      <div class="form-group row mt-2">
        <label class="col-sm-3 col-form-label">End Date</label>
        <div class="col-sm-9">
          <input type="date" class="form-control" [(ngModel)]="endDate">
        </div>
      </div>
      <p class="text-muted mt-2">
        <small>Leave blank to include all dates.</small>
      </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
      <button class="btn btn-primary" (click)="onContinue()">Continue</button>
    </div>
    </div>
  `
})
export class ExcelDateRangeModalComponent {
  startDate = '';
  endDate = '';
  onConfirm: (startDate: string, endDate: string) => void;

  constructor(public bsModalRef: BsModalRef) {}

  onContinue() {
    this.onConfirm(this.startDate, this.endDate);
    this.bsModalRef.hide();
  }

  onCancel() {
    this.bsModalRef.hide();
  }
}
